// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__P6Zlt","title":"Footer_title__tADfL","list":"Footer_list__FvoeW"};